import { motion } from 'framer-motion';
import { ArrowRight, Gift, Star, Plane, CreditCard } from 'lucide-react';
import Layout from '@/components/Layout';
import { springPresets } from '@/lib/motion';

const EARN_TABLE = [
  { flight: '广州 (CAN) → 达累斯萨拉姆 (DAR)', distance: '10,178 km', eco: '5,000', biz: '10,000' },
  { flight: '广州 (CAN) → 桑给巴尔 (ZNZ)', distance: '10,045 km', eco: '5,000', biz: '10,000' },
  { flight: '达累斯萨拉姆 → 乞力马扎罗 (JRO)', distance: '326 km', eco: '500', biz: '1,000' },
  { flight: '达累斯萨拉姆 → 桑给巴尔 (ZNZ)', distance: '72 km', eco: '300', biz: '600' },
];

const REDEEM_TABLE = [
  { route: '坦桑尼亚国内短途', eco: '5,000 里程', biz: '—' },
  { route: '广州 ↔ 达累斯萨拉姆', eco: '30,000 里程', biz: '60,000 里程' },
  { route: '广州 ↔ 桑给巴尔', eco: '30,000 里程', biz: '60,000 里程' },
  { route: '亚洲/非洲区域', eco: '20,000 里程', biz: '40,000 里程' },
  { route: '升舱至公务舱', eco: '—', biz: '10,000 里程' },
];

export default function TwigaMiles() {
  return (
    <Layout>
      {/* Hero */}
      <section className="relative h-96 overflow-hidden">
        <img src="/images/experience.jpg" alt="Twiga Miles" className="w-full h-full object-cover object-[center_30%]" />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary/50 to-secondary/80" />
        <div className="absolute inset-0 flex items-center pt-20">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex items-center gap-2 text-accent text-sm font-semibold mb-2">🦒 常旅客积分计划</div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">Twiga Miles</h1>
            <p className="text-white/70">飞行赚里程 · 里程换机票 · 专属会员权益</p>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="py-16 bg-background">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-14">
            <div>
              <h2 className="text-2xl font-bold mb-4">什么是 Twiga Miles？</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Twiga Miles 是坦桑尼亚航空的官方常旅客积分计划。"Twiga"在斯瓦希里语中意为"长颈鹿"，象征航空公司的品牌形象与非洲文化。
              </p>
              <p className="text-muted-foreground leading-relaxed mb-6">
                每次乘坐 Air Tanzania 航班，您都将获得相应的里程积分。积累足够里程后，可兑换免费机票、舱位升级、机场贵宾室使用权，以及合作伙伴提供的专属优惠。
              </p>
              <div className="flex flex-wrap gap-4 mb-6">
                {[
                  { icon: Plane, label: '飞行赚里程', color: 'text-primary bg-primary/10' },
                  { icon: Gift, label: '里程兑机票', color: 'text-accent bg-accent/10' },
                  { icon: Star, label: '会员等级升级', color: 'text-yellow-500 bg-yellow-50' },
                  { icon: CreditCard, label: '合作伙伴积分', color: 'text-green-600 bg-green-50' },
                ].map((item) => (
                  <div key={item.label} className="flex items-center gap-2 px-4 py-2.5 bg-muted rounded-xl border border-border text-sm font-medium">
                    <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${item.color}`}>
                      <item.icon size={15} />
                    </div>
                    {item.label}
                  </div>
                ))}
              </div>
              <a
                href="https://www.airtanzania.co.tz/twiga-miles"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-secondary text-white rounded-xl font-semibold hover:bg-secondary/90 transition-colors"
              >
                立即注册 Twiga Miles <ArrowRight size={16} />
              </a>
            </div>
            <div className="grid grid-cols-1 gap-5">
              <img src="/images/crew-smile.jpg" alt="服务团队" className="rounded-2xl object-cover object-[center_20%] w-full" style={{height:'260px'}} />
              <img src="/images/crew-model.jpg" alt="品牌形象" className="rounded-2xl object-cover object-[center_15%] w-full" style={{height:'260px'}} />
            </div>
          </div>

          {/* CTA */}
          <div className="mt-4 p-6 bg-primary/5 border border-primary/20 rounded-2xl text-center">
            <p className="text-muted-foreground text-sm mb-3">加入 Twiga Miles，开始积累您的飞行里程</p>
            <a
              href="https://www.airtanzania.co.tz/twiga-miles"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent text-accent-foreground rounded-xl font-bold text-sm hover:bg-accent/90 transition-colors"
            >
              前往官网注册会员
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
